import { FileSpreadsheet } from 'lucide-react';
import { PantallaReporte } from '@components/PantallaReporte';
import { ReporteAbmWebFiltros } from '@components/ReporteAbmWebFiltros';
import { ReporteAbmWebTabla } from '@components/ReporteAbmWebTabla';
import {
  REPORTE_ABM_WEB_PAGE_SIZE,
  getReporteAbmWeb,
  type ReporteAbmWebParams,
  type ReporteAbmWebRow,
} from '@lib/services/reporteAbmWeb';

/**
 * Reporte ABM Web Empresas (VEN-488): vista de solo lectura que muestra
 * altas y bajas de personas/legajos filtradas por estado y rango de fecha.
 * Accesible para roles Medicus (ADMIN, SUPERADMIN, USER_MEDICUS) y para la
 * organización, acotada a la suya. La paginación y la descarga las arma
 * `PantallaReporte`, compartida con el Reporte de padrón.
 */
export function ReporteAbmWebPage() {
  return (
    <PantallaReporte<ReporteAbmWebParams, ReporteAbmWebRow>
      titulo="Reporte ABM Web Empresas"
      descripcion="Altas y bajas de personas/legajos filtradas por estado y rango de fecha. Solo lectura."
      icono={<FileSpreadsheet size={22} style={{ color: 'var(--color-primary-darker)' }} />}
      clave="reporte-abm-web"
      obtener={getReporteAbmWeb}
      pageSize={REPORTE_ABM_WEB_PAGE_SIZE}
      filtros={(buscar, loading) => <ReporteAbmWebFiltros onBuscar={buscar} loading={loading} />}
      tabla={(rows, loading) => <ReporteAbmWebTabla rows={rows} loading={loading} />}
    />
  );
}
